import * as React from 'react';
import {connect} from 'react-redux';

import type {FilterObject} from 'nutshell-core/types';

import {openComposerWithId} from '../../../email/email-composer-actions';
import {ListProviderContext} from '../../../email-marketing/entity-lists/list-provider-context';
// @ts-expect-error
import * as dashboardActions from '../../../master-dashboard/dashboard-actions';
// @ts-expect-error
import {getContactsSchema} from '../../../master-dashboard/dashboard-selectors';

import type {NutshellState} from '../../../../store';

import * as actions from '../../forms-actions';
import * as selectors from '../../forms-selectors';

type OwnProps = {
    children: React.ReactNode;
};

type StateProps = {
    schema: any;
    count: number;
    isFirstLoad: boolean;
    isLoading: boolean;
    hasError: boolean;
    listItems: any[];
    isFilterDrawerOpen: boolean;
};

type DispatchProps = {
    fetchList: (arg1: FilterObject[], arg2: number, arg3: string[], sort: string, q: string) => any;
    fetchContactsSchema: () => void;
    toggleShowFilterDrawer: () => void;
    onClickEmailButtonForSingleEntity: (entityId: string) => void;
};

type Props = OwnProps & StateProps & DispatchProps;

function mapStateToProps(state: NutshellState): StateProps {
    return {
        schema: getContactsSchema(state),
        isFirstLoad: selectors.getFormSubmissionsListIsFirstLoad(state),
        isLoading: selectors.getFormSubmissionsListIsLoading(state),
        hasError: selectors.getFormSubmissionsListHasError(state),
        listItems: selectors.getFormSubmissionsListItems(state),
        count: selectors.getFormSubmissionsListCount(state),
        isFilterDrawerOpen: selectors.getIsFilterDrawerOpen(state),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        fetchContactsSchema: () => {
            dispatch(dashboardActions.fetchContactsSchema());
        },
        fetchList: (
            filters: FilterObject[],
            pageNum: number,
            columns: string[],
            sort: string,
            q: string
        ) => {
            dispatch(actions.requestFormSubmissionsListData({filters, pageNum, columns, sort, q}));
        },
        toggleShowFilterDrawer: () => {
            dispatch(actions.toggleShowFilterDrawer());
        },
        onClickEmailButtonForSingleEntity: (entityId) => {
            dispatch(openComposerWithId(entityId, true));
        },
    };
}

class FormRespondentsListProviderComponent extends React.Component<Props> {
    render() {
        const {
            schema,
            isFirstLoad,
            isLoading,
            hasError,
            listItems,
            count,
            isFilterDrawerOpen,
            fetchContactsSchema,
            fetchList,
            toggleShowFilterDrawer,
            onClickEmailButtonForSingleEntity,
        } = this.props;

        return (
            <ListProviderContext.Provider
                // @ts-expect-error
                value={{
                    schema,
                    isFirstLoad,
                    isLoading,
                    hasError,
                    listItems,
                    count,
                    isFilterDrawerOpen,
                    fetchContactsSchema,
                    fetchList,
                    toggleShowFilterDrawer,
                    onClickEmailButtonForSingleEntity,
                }}
            >
                {this.props.children}
            </ListProviderContext.Provider>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const FormRespondentsListProvider = connector(FormRespondentsListProviderComponent);
